import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { companyInfo } from '@/mocks/companyData';

export default function CookiePolicy() {
  const lastModified = '2025年4月1日';

  return (
    <div className="min-h-screen">
      <Navbar />

      {/* Hero */}
      <section className="pt-32 pb-16 md:pt-40 md:pb-20 bg-background-100">
        <div className="max-w-[1280px] mx-auto px-6 md:px-10">
          <div className="max-w-3xl">
            <span className="inline-block text-xs font-medium tracking-[0.15em] text-primary-600 bg-primary-100/70 px-4 py-1.5 rounded-full mb-6">
              COOKIE POLICY
            </span>
            <h1 className="font-heading text-3xl md:text-5xl font-bold text-foreground-900 leading-tight mb-6 tracking-wide">
              Cookie ポリシー
            </h1>
            <p className="text-sm text-foreground-500">
              最終更新日：{lastModified}
            </p>
          </div>
        </div>
      </section>

      {/* Full Policy Text */}
      <section className="py-16 md:py-20">
        <div className="max-w-[1280px] mx-auto px-6 md:px-10">
          <div className="max-w-3xl">
            <article className="prose prose-sm max-w-none text-foreground-700 leading-relaxed space-y-8">

              <div>
                <h2 className="font-heading text-lg font-bold text-foreground-900 mb-4 tracking-wide">1. Cookieとは</h2>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  Cookie（クッキー）とは、お客様がウェブサイトを訪問した際に、ウェブサーバーからお客様のブラウザに送信され、お客様のコンピュータやモバイルデバイスに保存される小さなテキストファイルです。Cookieには、お客様のサイト訪問日時、閲覧ページ、設定情報などが記録されます。
                </p>
              </div>

              <div>
                <h2 className="font-heading text-lg font-bold text-foreground-900 mb-4 tracking-wide">2. Cookieの利用目的</h2>
                <p className="text-sm text-foreground-600 leading-relaxed mb-3">
                  {companyInfo.name}（以下「当社」といいます。）では、以下の目的でCookieを使用しています。
                </p>
                <ul className="list-disc pl-6 space-y-2">
                  <li className="text-sm text-foreground-600 leading-relaxed">
                    <strong className="text-foreground-800">必須Cookie：</strong>
                    ウェブサイトの基本的な機能を提供するために必要なCookieです。サイトのナビゲーションやセキュリティ機能の維持に使用されます。
                  </li>
                  <li className="text-sm text-foreground-600 leading-relaxed">
                    <strong className="text-foreground-800">パフォーマンスCookie：</strong>
                    サイトの利用状況（アクセス数、滞在時間、閲覧ページなど）を匿名で収集・分析し、サイトの改善に役立てるためのCookieです。Google Analytics等のツールを使用しています。
                  </li>
                  <li className="text-sm text-foreground-600 leading-relaxed">
                    <strong className="text-foreground-800">機能性Cookie：</strong>
                    お客様の選択（言語設定、地域設定など）を記憶し、よりパーソナライズされた体験を提供するためのCookieです。
                  </li>
                </ul>
              </div>

              <div>
                <h2 className="font-heading text-lg font-bold text-foreground-900 mb-4 tracking-wide">3. 使用するCookieの種類</h2>
                <p className="text-sm text-foreground-600 leading-relaxed mb-3">
                  当社のウェブサイトでは、以下の種類のCookieを使用しています。
                </p>
                <div className="overflow-x-auto">
                  <table className="w-full text-sm border-collapse">
                    <thead>
                      <tr className="border-b border-background-300">
                        <th className="text-left py-3 px-4 text-xs font-semibold text-foreground-500 tracking-wider">Cookie名</th>
                        <th className="text-left py-3 px-4 text-xs font-semibold text-foreground-500 tracking-wider">種類</th>
                        <th className="text-left py-3 px-4 text-xs font-semibold text-foreground-500 tracking-wider">目的</th>
                        <th className="text-left py-3 px-4 text-xs font-semibold text-foreground-500 tracking-wider">保存期間</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr className="border-b border-background-200">
                        <td className="py-3 px-4 text-foreground-700">_ga</td>
                        <td className="py-3 px-4 text-foreground-500">パフォーマンス</td>
                        <td className="py-3 px-4 text-foreground-500">Google Analytics - ユーザー識別</td>
                        <td className="py-3 px-4 text-foreground-500">2年間</td>
                      </tr>
                      <tr className="border-b border-background-200">
                        <td className="py-3 px-4 text-foreground-700">_gid</td>
                        <td className="py-3 px-4 text-foreground-500">パフォーマンス</td>
                        <td className="py-3 px-4 text-foreground-500">Google Analytics - セッション管理</td>
                        <td className="py-3 px-4 text-foreground-500">24時間</td>
                      </tr>
                      <tr className="border-b border-background-200">
                        <td className="py-3 px-4 text-foreground-700">session_id</td>
                        <td className="py-3 px-4 text-foreground-500">必須</td>
                        <td className="py-3 px-4 text-foreground-500">セッション管理</td>
                        <td className="py-3 px-4 text-foreground-500">セッション終了まで</td>
                      </tr>
                      <tr className="border-b border-background-200">
                        <td className="py-3 px-4 text-foreground-700">lang_pref</td>
                        <td className="py-3 px-4 text-foreground-500">機能性</td>
                        <td className="py-3 px-4 text-foreground-500">言語設定の保存</td>
                        <td className="py-3 px-4 text-foreground-500">1年間</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div>
                <h2 className="font-heading text-lg font-bold text-foreground-900 mb-4 tracking-wide">4. Cookieの拒否・無効化の方法</h2>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  お客様は、ご利用のブラウザの設定を変更することにより、Cookieの受け入れを拒否したり、Cookieを受け取った際に警告を表示させたりすることができます。ただし、Cookieを無効化した場合、本サイトの一部の機能が正常に動作しなくなる可能性があります。
                </p>
                <p className="text-sm text-foreground-600 leading-relaxed mt-3">
                  各ブラウザのCookie設定方法については、以下をご参照ください。
                </p>
                <ul className="list-disc pl-6 space-y-2 mt-3">
                  <li className="text-sm text-foreground-600 leading-relaxed">Google Chrome：設定 &gt; プライバシーとセキュリティ &gt; Cookie と他のサイトデータ</li>
                  <li className="text-sm text-foreground-600 leading-relaxed">Mozilla Firefox：オプション &gt; プライバシーとセキュリティ &gt; Cookie とサイトデータ</li>
                  <li className="text-sm text-foreground-600 leading-relaxed">Apple Safari：Safari &gt; 環境設定 &gt; プライバシー</li>
                  <li className="text-sm text-foreground-600 leading-relaxed">Microsoft Edge：設定 &gt; Cookie とサイトのアクセス許可</li>
                </ul>
              </div>

              <div>
                <h2 className="font-heading text-lg font-bold text-foreground-900 mb-4 tracking-wide">5. 第三者によるCookie</h2>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  当社では、アクセス解析のためにGoogle Analytics等の第三者が提供するサービスを利用しています。これらの第三者は、当社サイトの利用状況を分析するためにCookieを使用することがあります。第三者によるCookieの取り扱いについては、各提供元のプライバシーポリシーをご確認ください。
                </p>
              </div>

              <div>
                <h2 className="font-heading text-lg font-bold text-foreground-900 mb-4 tracking-wide">6. Cookieポリシーの変更</h2>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  当社は、必要に応じて本ポリシーの内容を変更することがあります。変更後のCookieポリシーは、本ウェブサイトに掲載した時点から効力を生じるものとします。
                </p>
              </div>

              <div>
                <h2 className="font-heading text-lg font-bold text-foreground-900 mb-4 tracking-wide">7. お問い合わせ</h2>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  本ポリシーに関するお問い合わせは、下記までお願いいたします。
                </p>
                <div className="mt-3 text-sm text-foreground-600 leading-relaxed space-y-1">
                  <p>{companyInfo.name}</p>
                  <p>所在地：{companyInfo.address}</p>
                  <p>E-mail：<a href={`mailto:${companyInfo.email}`} className="text-primary-600 hover:text-primary-700 underline">{companyInfo.email}</a></p>
                </div>
              </div>

            </article>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}